import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface NetMemoState {
  netMemoFrom: boolean;
  netMemoTo: boolean;
}

const initialState: NetMemoState = {
  netMemoFrom: false,
  netMemoTo: false,
};

export const netMemoSlice = createSlice({
  name: "netMemoSlice",
  initialState,
  reducers: {
    setNetMemoFromData: (state, action: PayloadAction<boolean>) => {
      state.netMemoFrom = action.payload;
    },
    setNetMemoToData: (state, action: PayloadAction<boolean>) => {
      state.netMemoTo = action.payload;
    },
  },
});

export const { setNetMemoFromData, setNetMemoToData } = netMemoSlice.actions;

export default netMemoSlice.reducer;
